import React from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useSelector } from "react-redux"

const Summary = () => {
  const { cards } = useSelector(state => state.Dashboard)

  return (
    <React.Fragment>
      <Row>
        {cards &&
          cards.map((report, key) => (
            <Col
              md="3"
              sm="6"
              xs="12"
              key={"_col_" + key}
              className="mb-3 border-0"
            >
              <div
                className="text-white shadow border-0 rounded-2"
                style={{
                  backgroundColor: report.BackgroundColor || "#007bff",
                  minHeight: "160px",
                }}
              >
                <div className="d-flex align-items-center p-4">
                  <i
                    className={`bx ${report.IconClass} me-3`}
                    style={{
                      fontSize: "6rem",
                      opacity: 0.9,
                      lineHeight: 1,
                    }}
                  ></i>
                  <div>
                    <h2
                      className="fw-bold mb-1"
                      style={{ fontSize: "2.5rem", lineHeight: 1 }}
                    >
                      {report.Value}
                    </h2>
                    <p
                      className="mb-0 text-uppercase fw-semibold"
                      style={{
                        fontSize: "1rem",
                        letterSpacing: "0.5px",
                        opacity: 0.85,
                      }}
                    >
                      {report.Title}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </React.Fragment>
  )
}

export default Summary
